module.exports = __webpack_public_path__ + "img/quattro2.293a9b24.png";